import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=f935381c&"
import script from "./Item.vue?vue&type=script&lang=js&"
export * from "./Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f935381c')) {
      api.createRecord('f935381c', component.options)
    } else {
      api.reload('f935381c', component.options)
    }
    module.hot.accept("./Item.vue?vue&type=template&id=f935381c&", function () {
      api.rerender('f935381c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/pricing-guides/Item.vue"
export default component.exports